import moment from 'moment'

export const projectName= "Dummy Project"
export const serverErrorMessage= "Something Went Wrong!"

export const custTime= "9 AM"

export const selectableTimes= ["9 AM", "10 AM", "11 AM", "12 PM", "1 PM", "2 PM", "3 PM", "4 PM", "5 PM", "6 PM", "7 PM", "8 PM", "9 PM"]

export const scheduleConfUrl = 'public_api/leads'
export const bookingUrl = 'public/bookings/new'

export const paymentPlans = ['CLP', 'EMI Scheme', 'EMI+CLP', 'Subvention 1:99', 'Subvention 10:90']

export function confCallParams(callParams){
  let toSend = {}
  toSend['name'] = callParams.custName
  toSend['email'] = callParams.custEmail
  toSend['phone'] = callParams.custPhone
  toSend['date'] = callParams.custDate ? moment(callParams.custDate).format("DD-MM-YYYY") : null
  toSend['time'] = callParams.custTime
  toSend['project'] = projectName
  return toSend
}

export function santizeBookingParams(bParams){
  let toSend = {}
  if(bParams.leadNo){
    toSend['ln'] = bParams.leadNo
  }else{
    toSend['p'] = projectName
  }
  toSend['t'] = bParams.typologyName
  toSend['f'] = bParams.floorName
  toSend['in'] = bParams.flatName
  toSend['wi'] = bParams.wingName
  toSend['pn'] = bParams.selectedPlan
  toSend['cpuu'] = bParams.cpId
  return toSend
}

export const masterJson = 
{
  "Typologies" : [
    {
      "key": "3bhk-c1",
      "value": "3 BHK Type C1",
      "buildings": ["wing2", "wing3", "wing4", "wing5", "wing6", "wing7", "wing8", "wing9", "wing11", "wing12", "wing13"],
      "floors": ["floorseta", "floorsetb", "floorsetc", "floorsetd", "floorsete", "floorsetf"],
      "priceRange": "1.23 - 1.26",
      "area": "1490"
    },
    {
      "key": "3bhk-b1",
      "value": "3 BHK Type B1",
      "buildings": ["wing1", "wing2", "wing4", "wing5", "wing10", "wing11", "wing13", "wing14"],
      "floors": ["floorseta", "floorsetb", "floorsetc", "floorsetd", "floorsete", "floorsetf"],
      "priceRange": "1.24 - 1.27",
      "area": "1507"
    },
    {
      "key": "3bhk-a1",
      "value": "3 BHK Type A1",
      "buildings": ["wing1", "wing2", "wing3", "wing4", "wing5", "wing6", "wing9", "wing10", "wing11", "wing12", "wing14"],
      "floors": ["floorseta", "floorsetb", "floorsetc", "floorsetd", "floorsete", "floorsetf"],
      "priceRange": "1.5 - 1.55",
      "area": "1804"
    },
    {
      "key": "3bhk-a2",
      "value": "3 BHK Type A2",
      "buildings": ["wing3", "wing4", "wing2", "wing11", "wing12", "wing13"],
      "floors": ["floorseta", "floorsetb", "floorsetc", "floorsetd", "floorsete", "floorsetf"],
      "priceRange": "1.55 -1.6",
      "area": "1884"
    },
    {
      "key": "4bhk-h1",
      "value": "4 BHK Type H1",
      "buildings": ["wing16", "wing15"],
      "floors": ["floorseta", "floorsetb", "floorsetc", "floorsetd", "floorsete", "floorsetf"],
      "priceRange": "2 - 2.05",
      "area": "2182"
    },
    {
      "key": "4bhk-f",
      "value": "4 BHK Type F",
      "buildings": ["wing16", "wing15"],
      "floors": ["floorseta", "floorsetb", "floorsetc", "floorsetd", "floorsete", "floorsetf"],
      "priceRange": "2.05- 2.10",
      "area": "2232"
    }
  ],
  "Buildings" : [
    {
      "key": "wing1",
      "value": "Wing 1",
      "polygon": "3891.2 1829.33 3954.13 1829.33 3954.13 1752.53 3939.2 1752.53 3938.6 1691.73 3954.13 1691.73 3954.13 1631.47 3932.27 1631.47 3932.8 1634.13 3905.6 1634.67 3904 1620.8 3877.33 1620.8 3877.33 1675.2 3858.67 1675.2 3858.67 1687.47 3852.27 1688 3852.27 1620.8 3825.07 1620.8 3825.07 1635.2 3794.67 1634.73 3794.67 1631.47 3773.87 1631.47 3773.87 1691.2 3793.07 1692.27 3793.07 1710.4 3830.4 1712 3830.4 1731.27 3792.53 1731.2 3790.93 1751.47 3773.87 1752.53 3773.87 1829.33 3837.87 1829.33 3837.87 1784 3890.13 1784.53 3891.2 1829.33"
    },
    {
      "key": "wing2",
      "value": "Wing 2",
      "polygon": "3890.67 1409.13 3954.13 1408 3954.13 1486.93 3939.67 1486.93 3940.27 1548.8 3954.13 1548.8 3954.13 1608 3932.8 1608 3932.27 1604.73 3904.53 1605.33 3904 1620.8 3877.33 1620.8 3877.33 1562.67 3851.73 1563.73 3852.27 1620.8 3825.07 1620.8 3825.07 1605.87 3796.27 1605.33 3796.27 1609.6 3773.87 1608.53 3773.87 1550.4 3791.47 1549.33 3790.93 1527.87 3831.47 1526.93 3831.47 1508.27 3792.53 1508.27 3792.47 1488.53 3773.87 1488.4 3773.87 1416 3832 1416 3831.47 1456 3864 1456 3892.33 1456.53 3890.67 1409.13"
    },
    {
      "key": "wing3",
      "value": "Wing 3",
      "polygon": "3773.87 1210.67 3833.6 1210.67 3833.6 1283.2 3814.93 1283.2 3814.4 1344.53 3833.6 1344.53 3830.93 1413.87 3773.87 1413.87 3773.87 1374.4 3714.13 1374.4 3714.13 1422.93 3650.67 1422.93 3650.67 1344 3668.27 1344 3667.2 1322.67 3712 1322.13 3712 1304.53 3667.2 1304.53 3667.2 1282.67 3650.67 1282.67 3650.67 1203.2 3714.67 1203.2 3714.13 1248.53 3773.87 1249.07 3773.87 1210.67"
    },
    {
      "key": "wing4",
      "value": "Wing 4",
      "polygon": "3824.8 1007.2 3824.8 1017.6 3824.8 1021.2 3797.6 1021.2 3797.6 1015.2 3775.2 1015.2 3775.2 1076 3791.2 1076 3791.2 1096 3830.4 1096 3830.4 1112.8 3791.2 1112.8 3791.2 1136.8 3775.2 1136.8 3773.87 1210.67 3830.4 1210.67 3830.4 1171.2 3891 1172 3889.6 1218.4 3952.8 1218.4 3952.8 1140 3940 1140 3940 1077.6 3952.8 1077.6 3952.8 1018.4 3933.6 1018.4 3931.2 1022.4 3904.8 1018.4 3904.8 1007.2 3876.8 1007.2 3876.8 1060 3859.2 1061.6 3859.2 1069.6 3851 1070.4 3851 1007.2"
    },
    {
      "key": "wing5",
      "value": "Wing 5",
      "polygon": "3890.2 792.8 3955.8 792.8 3956 872 3937.6 872 3937.6 932.8 3952.8 932.8 3952.8 996 3933.4 996 3933.6 992.2 3904.4 992 3904.4 1007.2 3876.8 1007.2 3876.8 948.4 3857.4 948.6 3857.4 938.6 3849.33 938.07 3850.4 1006.6 3825.33 1007.07 3825.33 993 3775.2 993.33 3775.2 935.73 3790.27 936 3790.13 913.07 3830.4 913.33 3830.4 894.67 3787.2 895.47 3787.2 875.73 3773.87 875.2 3773.87 792.8 3837.33 792.8 3837.87 839.47 3890.13 840 3890.2 792.8"
    },
    {
      "key": "wing6",
      "value": "Wing 6",
      "polygon": "3599.47 612.27 3680 612.27 3680 629.87 3739.73 629.87 3739.73 614.93 3820.8 614.93 3820.8 678.93 3773.87 678.93 3773.87 700.8 3773.87 737.07 3814.4 737.07 3812.8 792.8 3742.4 793.8 3742.4 779.73 3721.07 779.2 3720 740.8 3701.87 740.27 3703.47 781.87 3680 779.73 3680.53 793.8 3608.53 793.8 3608.53 736 3648 738.13 3648.53 721.6 3651.2 721.6 3651.73 705.07 3645.33 705.07 3644.27 678.4 3599.47 677.33 3599.47 612.27"
    },
    {
      "key": "wing7",
      "value": "Wing 7",
      "polygon": "3610.67 860.8 3610.67 924.13 3534.93 924.13 3534.93 906.13 3513.07 905.6 3513.07 865.6 3495.47 864.53 3495.47 905.07 3475.2 905.07 3475.2 923.13 3409.07 923.13 3409.07 841.6 3451.2 843.27 3450.67 816 3409.07 813.87 3409.07 734.4 3474.67 734.4 3474.13 752.53 3531.73 752 3531.2 734.4 3608.53 736 3607.4 792.8 3567.47 793.8 3568.53 860.8 3610.67 860.8"
    },
    {
      "key": "wing8",
      "value": "Wing 8",
      "polygon": "3082.13 735.4 3082.13 751.53 3144 751.53 3144 736.53 3212.27 737.07 3212.27 815.47 3166.4 815.47 3165.87 842.13 3210.13 842.13 3212.27 920.53 3144 924.13 3144 906.13 3122.13 904.53 3122.67 866.13 3103.47 866.13 3103.47 905.6 3082.13 905.6 3082.13 920.53 3010.67 921.07 3010.67 864 3049.6 866.13 3049.6 793.8 3010.67 793.8 3010.67 737.6 3082.13 735.4"
    },
    {
      "key": "wing9",
      "value": "Wing 9",
      "polygon": "2876.8 614.4 2876.8 630.4 2936.53 630.4 2936.53 614.4 3017.6 614.4 3017.6 677.33 2971.2 680 2971.2 702.4 2969.6 738.13 3009.53 738.13 3009.47 793.07 2937.6 793.07 2937.6 779.2 2918.4 778.13 2917.87 740.27 2897.07 739.2 2898.13 779.2 2876.8 778.67 2876.8 793.07 2803.73 793.07 2803.73 739.73 2845.33 738.67 2844.8 677.87 2799.47 677.33 2799.47 614.4 2876.8 614.4"
    },
    {
      "key": "wing10",
      "value": "Wing 10",
      "polygon": "2779.73 793.07 2842.13 793.07 2842.13 872 2827.2 872 2827.2 894.4 2785.07 894.4 2785.6 912.53 2827.73 912.53 2827.73 934.93 2842.13 934.93 2842.13 962.13 2845.33 965.87 2845.33 995.2 2822.4 995.2 2822.4 990.93 2793.6 990.93 2793.6 1005.87 2714.13 1005.87 2714.13 992.53 2684.8 990.4 2684.8 994.13 2664 992.53 2664 934.93 2680.53 935.47 2680 873.07 2664 873.07 2664 793.07 2728 793.07 2726.93 841.07 2780.27 841.07 2779.73 793.07"
    },
    {
      "key": "wing11",
      "value": "Wing 11",
      "polygon": "2788.27 1209.07 2845.33 1209.07 2845.33 1137.6 2827.73 1137.6 2827.13 1114.67 2788.27 1114.67 2788.27 1099.2 2827.73 1099.2 2827.2 1077.87 2845.33 1077.87 2845.33 1016 2822.4 1016 2822.93 1020.27 2792.53 1020.8 2793.6 1005.87 2714.13 1005.87 2714.13 1020.27 2685.33 1020.27 2667.73 1020.27 2667.73 1078.4 2680.53 1078.33 2679.47 1138.13 2665.73 1138.67 2664 1216 2726.93 1216 2726.93 1170.67 2787.67 1169.6 2788.27 1209.07"
    },
    {
      "key": "wing12",
      "value": "Wing 12",
      "polygon": "2788.27 1415.47 2842.67 1415.47 2842.67 1377.6 2905.07 1377.6 2905.07 1420.8 2968.53 1420.8 2968.53 1345.07 2952 1345.07 2951.47 1323.2 2907.73 1323.2 2908.27 1304.53 2950.93 1304.53 2949.8 1282.11 2966.93 1282.11 2968.53 1204.27 2904 1204.27 2904.53 1250.67 2842.67 1249.6 2842.67 1211.73 2788.27 1211.73 2788.27 1282.11 2803.73 1282.11 2804.27 1342.93 2788.27 1342.93 2788.27 1415.47"
    },
    {
      "key": "wing13",
      "value": "Wing 13",
      "polygon": "2714.13 1619.2 2793.07 1619.2 2793.07 1605.87 2823.47 1605.87 2823.47 1609.6 2844.27 1605.87 2844.27 1547.73 2828.27 1547.73 2828.27 1525.87 2788.27 1525.87 2788.27 1508.8 2827.67 1508.8 2828.2 1488 2844.27 1488 2844.27 1417.6 2788.27 1415.47 2788.27 1454.93 2726.4 1456 2726.4 1408.53 2665.07 1408.53 2665.07 1488.53 2680.53 1488 2680.07 1548.8 2665.07 1548.8 2665.07 1608 2684.8 1606.93 2683.73 1604.2 2714.13 1604.27 2714.13 1619.2"
    },
    {
      "key": "wing14",
      "value": "Wing 14",
      "polygon": "2779.73 1830.93 2844.27 1830.93 2844.27 1752.53 2828.8 1752.53 2826.67 1729.6 2788.8 1729.6 2787.2 1713.07 2827.2 1713.07 2827.2 1692.8 2844.27 1692.8 2844.27 1632 2823.47 1632 2822.4 1634.67 2794.13 1634.67 2793.6 1621.4 2769.07 1621.4 2769.07 1683.2 2769.07 1686.93 2759.47 1685.87 2759.47 1676.27 2740.27 1675.73 2740.27 1619.8 2714.13 1619.2 2714.13 1635.2 2665.07 1633.6 2665.07 1690.67 2680 1690.67 2681.07 1750.93 2665.07 1750.93 2665.07 1830.93 2726.93 1830.93 2726.4 1784 2780.27 1783.47 2779.73 1830.93"
    },
    {
      "key": "wing15",
      "value": "Wing 15",
      "polygon": "1257.6 1444.8 1273.6 1387.2 1204.8 1371.2 1214.4 1339.2 1286.4 1353.6 1299.2 1296 1174.4 1262.4 1160 1328 1121.6 1318.4 1144 1248 1100.8 1236.8 1100.8 1246.4 1081.6 1236.8 1014.4 1214.4 1004 1258.8 985.6 1254.4 985.6 1230.4 974.4 1224 974.4 1212.4 853.6 1180 839.8 1242.8 905.6 1256 900.8 1282.11 836.8 1270.4 817.6 1328 934.4 1361.6 953.6 1299.2 992 1310.4 974.4 1374.4 1006.4 1384 1011.2 1372.8 1033.6 1380.8 1030.4 1392 1099.2 1408 1113.6 1339.2 1134.4 1343.2 1124.8 1379.2 1145.6 1384 1137.6 1412.8 1257.6 1444.8"
    },
    {
      "key": "wing16",
      "value": "Wing 16",
      "polygon": "620 752 744 784.8 739.2 797.6 757.6 802.4 751.2 825.6 771.2 833.6 781.6 786.4 852 808 852 816 868.8 821.6 868.8 812 912 821.6 891.2 893.6 924.8 901.6 944 833.6 1066.4 868.8 1051.2 928 981.6 915.2 977.6 937.6 977.6 944 1044.8 960 1028.8 1020.8 904 988.8 910.4 958.4 892 952.8 902.4 917.6 886.4 913.6 865.6 982.4 797.6 966.4 796.8 956 779.2 952 777.6 958.4 739.2 951.2 760.8 879.2 721.6 868.8 704.8 935.2 578.4 906.4 598.4 843.2 661.6 860 670.4 831.2 605.6 815.2 620 752"
    }
  ],
  "Floors" : [
    {
      "key": "floorseta",
      "value": "0 - 3rd Floor"
    },
    {
      "key": "floorsetb",
      "value": "4th - 6th Floor"
    },
    {
      "key": "floorsetc",
      "value": "7th - 9th Floor"
    },
    {
      "key": "floorsetd",
      "value": "10th - 12th Floor"
    },
    {
      "key": "floorsete",
      "value": "13th - 15th Floor"
    },
    {
      "key": "floorsetf",
      "value": "16th - 18th Floor"
    }
  ],
  "Wings" : [
    {
      "name" : "Wing 1",
      "flats" : [
        {
          "name" : "001",
          "floor" : "Floor 0",
          "status" : "Available"
        },
        {
          "name" : "002",
          "floor" : "Floor 0",
          "status" : "Booked"
        },
        {
          "name" : "003",
          "floor" : "Floor 0",
          "status" : "Available"
        },
        {
          "name" : "101",
          "floor" : "Floor 1",
          "status" : "Blocked"
        },
        {
          "name" : "102",
          "floor" : "Floor 1",
          "status" : "Available"
        },
        {
          "name" : "103",
          "floor" : "Floor 1",
          "status" : "Booked"
        },
        {
          "name" : "201",
          "floor" : "Floor 2",
          "status" : "Booked"
        },
        {
          "name" : "202",
          "floor" : "Floor 2",
          "status" : "Booked"
        },
        {
          "name" : "203",
          "floor" : "Floor 2",
          "status" : "Booked"
        },
        {
          "name" : "301",
          "floor" : "Floor 3",
          "status" : "Available"
        },
        {
          "name" : "302",
          "floor" : "Floor 3",
          "status" : "Blocked"
        },
        {
          "name" : "303",
          "floor" : "Floor 3",
          "status" : "Booked"
        },
        {
          "name" : "401",
          "floor" : "Floor 4",
          "status" : "Available"
        },
        {
          "name" : "402",
          "floor" : "Floor 4",
          "status" : "Blocked"
        },
        {
          "name" : "403",
          "floor" : "Floor 4",
          "status" : "Booked"
        }
      ]
    },
    {
      "name" : "Wing 2",
      "flats" : [
        {
          "name" : "001",
          "floor" : "Floor 0",
          "status" : "Booked"
        },
        {
          "name" : "002",
          "floor" : "Floor 0",
          "status" : "Available"
        },
        {
          "name" : "003",
          "floor" : "Floor 0",
          "status" : "Blocked"
        },
        {
          "name" : "101",
          "floor" : "Floor 1",
          "status" : "Blocked"
        },
        {
          "name" : "102",
          "floor" : "Floor 1",
          "status" : "Available"
        },
        {
          "name" : "103",
          "floor" : "Floor 1",
          "status" : "Booked"
        }
      ]
    },
    {
      "name" : "Wing 3",
      "flats" : [
        {
          "name" : "101",
          "floor" : "Floor 1",
          "status" : "Blocked"
        },
        {
          "name" : "102",
          "floor" : "Floor 1",
          "status" : "Available"
        },
        {
          "name" : "103",
          "floor" : "Floor 1",
          "status" : "Booked"
        },
        {
          "name" : "201",
          "floor" : "Floor 2",
          "status" : "Booked"
        },
        {
          "name" : "202",
          "floor" : "Floor 2",
          "status" : "Booked"
        },
        {
          "name" : "203",
          "floor" : "Floor 2",
          "status" : "Available"
        }
      ]
    }
  ]
}